import React from 'react'
import LoadingBar from 'react-redux-loading-bar'
import Routes from './Routes'
import Loader from './shared/component/loader/Loader'
import firebase from 'firebase/app'
import firebaseConfig from './firebase.config'
import { withRouter } from 'react-router-dom';

firebase.initializeApp(firebaseConfig);

class App extends React.Component {
  componentDidMount() {
    this.registerOnSignal();
  }

  registerOnSignal = () => {
    const OneSignal = window['OneSignal'];

    if (OneSignal) {
      OneSignal.push(function () {
        OneSignal.init({
          appId: "2ab1d2a6-918a-48fd-98fd-563a27bc5c0c",
          autoRegister: true
        });
      });

      OneSignal.addListenerForNotificationOpened(this.onNotificationOpened)
      return;
    }
    return this.registerOnSignal();
  }

  onNotificationOpened = (payload) => {
    if (payload.data.screen.toLowerCase().includes("orderservice")) {
        this.props.history.push(`/orderservice/${payload.data.orderServiceId}`)
    }
  }

  render() {
    return (
      <Loader>
        <LoadingBar
          style={{
            zIndex: 10000,
            backgroundColor: 'rgba(255, 204, 0)',
            height: '5px'
          }}
        />
        <Routes />
      </Loader>
    )
  }
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/App.js